import { TYPE_STRING } from './input-types';

export const id = 'requestedServiceMarketplace';
export const apiKey = 'RequestedServiceMarketPlace';
export const type = TYPE_STRING;

export const requestedServiceMarketplace = {
  id,
  apiKey,
  type,
};
